import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import { initSentry, SentryErrorBoundary } from './lib/sentry.js';
// Tipografía del producto, self-hosted (woff2, subset latin, swap): la misma
// familia que la landing. Anton solo para títulos (.nt-display).
import '@fontsource/anton/latin-400.css';
import '@fontsource/barlow/latin-400.css';
import '@fontsource/barlow/latin-500.css';
import '@fontsource/barlow/latin-600.css';
import '@fontsource/barlow/latin-700.css';
import '@fontsource/jetbrains-mono/latin-400.css';
import '@fontsource/jetbrains-mono/latin-500.css';
import '@fontsource/jetbrains-mono/latin-600.css';
import './styles/globals.css';

// Phase 2.10 Sentry — initialize BEFORE any React tree mounts so the
// SDK is armed for the first render's error path. No-op when
// VITE_SENTRY_DSN is unset.
initSentry();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

createRoot(container).render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={({ resetError }) => (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-nt-bg p-8 text-center text-nt-text">
          <h1 className="text-xl font-semibold">Algo se rompió.</h1>
          <p className="max-w-md text-sm text-nt-text-muted">
            Hubo un error inesperado. El equipo ya recibió el reporte automático. Refresca la página
            o prueba de nuevo en unos minutos.
          </p>
          <button
            type="button"
            onClick={() => resetError()}
            className="rounded-full bg-nt-brand-strong px-4 py-2 text-sm font-semibold text-white hover:bg-nt-brand"
          >
            Reintentar
          </button>
        </div>
      )}
    >
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
);
